import type { FormStructure, FormStructureItem } from 'utils/form/Form.types';
import generateForm from './generate-form';

const mergeMultipleForms = (
  formStructures: FormStructureItem[][],
  existingData: Record<string, any>,
): FormStructure => {
  let form = {
    errors: {},
    isTouched: {},
  };
  formStructures.forEach((fs) => {
    const {
      errors: newErrors,
      isTouched: newIsTouched,
      ...newFormRest
    } = generateForm(fs, existingData).form;
    const { errors, isTouched, ...formRest } = form;
    form = {
      ...formRest,
      ...newFormRest,
      errors: { ...errors, ...(newErrors as any) },
      isTouched: { ...isTouched, ...(newIsTouched as any) },
    };
  });
  return form;
};

export default mergeMultipleForms;
